import { render, staticRenderFns } from "./AppHeaderGallery.vue?vue&type=template&id=4073b5f3&scoped=true&"
import script from "./AppHeaderGallery.vue?vue&type=script&lang=ts&"
export * from "./AppHeaderGallery.vue?vue&type=script&lang=ts&"
import style0 from "./AppHeaderGallery.vue?vue&type=style&index=0&id=4073b5f3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4073b5f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
